import { render, staticRenderFns } from "./TotalListHead.vue?vue&type=template&id=9f6b766e"
import script from "./TotalListHead.vue?vue&type=script&lang=js"
export * from "./TotalListHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports